import React from 'react';
import Icon from '../../../components/AppIcon';
import { getProficiencyColor, getProficiencyWidth } from '../../../utils/proficiency';

const SkillCard = ({ skill, onClick }) => {
  return (
    <div 
      className="bg-white rounded-xl p-6 shadow-soft hover:shadow-medium transition-all duration-300 cursor-pointer group border border-border"
      onClick={() => onClick(skill)}
    >
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className={`w-12 h-12 rounded-lg ${skill?.color} flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
            <Icon name={skill?.icon} size={24} color="white" />
          </div>
          <div>
            <h3 className="font-semibold text-lg text-text-primary group-hover:text-accent transition-colors duration-300">
              {skill?.name}
            </h3>
            <p className="text-sm text-text-secondary">{skill?.category}</p>
          </div>
        </div>
        {skill?.isLearning && (
          <div className="flex items-center space-x-1 bg-accent/10 text-accent px-2 py-1 rounded-full text-xs font-medium">
            <Icon name="BookOpen" size={12} />
            <span>Learning</span>
          </div>
        )}
      </div>
      <div className="mb-4">
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm font-medium text-text-secondary">Proficiency</span>
          <span className="text-sm font-semibold text-text-primary">{skill?.proficiency}</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2">
          <div 
            className={`h-2 rounded-full transition-all duration-500 ${getProficiencyColor(skill?.proficiency)} ${getProficiencyWidth(skill?.proficiency)}`}
          ></div>
        </div>
      </div>
      <div className="flex items-center justify-between text-sm text-text-secondary">
        <div className="flex items-center space-x-1">
          <Icon name="Calendar" size={14} />
          <span>{skill?.experience} years</span>
        </div>
        <div className="flex items-center space-x-1">
          <Icon name="FolderOpen" size={14} />
          <span>{skill?.projects} projects</span>
        </div>
      </div>
      {skill?.certifications && skill?.certifications?.length > 0 && (
        <div className="mt-3 pt-3 border-t border-border">
          <div className="flex items-center space-x-1 text-xs text-success">
            <Icon name="Award" size={12} />
            <span>{skill?.certifications?.length} certification{skill?.certifications?.length > 1 ? 's' : ''}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default SkillCard;